import $ from 'jquery';

class BjzmScripts {
	
	constructor() {
		 this.startMatchHeight();
		 this.do_hamburger();
		 this.isHamburgerOpen = false;
	}

	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		})
	}

	openMobileMenu() {
		$("body").addClass("navigation--active");
		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		$("body").removeClass("navigation--active");
		this.isHamburgerOpen = false;
	}

	startMatchHeight() {
	/*	$('.bjzm-match-height').matchHeight({
			byRow: false
		});*/
	}
	
}

module.exports = BjzmScripts;